// extracted by mini-css-extract-plugin
export default {"account-container":"FonrVL","title":"FrV1nF"};